export { AuthTemplate, AUTH_CONTENT_WIDTH, AUTH_LOGO_HEIGHT } from "./AuthTemplate"
export type { AuthTemplateProps } from "./AuthTemplate"
